export default __webpack_public_path__ + "static/media/downArrow.7bcb66cc.svg";